
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/Enterprise/List', formData);
}

const AddEdit = async (formData: FormData) => {
    return AxiosHelper.post('/Enterprise/AddEdit', formData);
}

const Remove = async (formData: FormData) => {
    return AxiosHelper.post('/Enterprise/Remove', formData);
}

const TestDatabaseConnection = async (formData: FormData) => {
    return AxiosHelper.post('/Enterprise/TestDatabaseConnection', formData);
}

const TestApiConnection = async (formData: FormData) => {
    return AxiosHelper.post('/Enterprise/TestApiConnection', formData);
}


const EnterpriseService = {
    List,
    AddEdit,
    Remove,
    TestDatabaseConnection,
    TestApiConnection
}

export default EnterpriseService;